// extracted by mini-css-extract-plugin
export var bottom = "CookieConsent-module--bottom--4X6WJ";
export var bottomLeft = "CookieConsent-module--bottomLeft--4vOm-";
export var bottomRight = "CookieConsent-module--bottomRight--MohJa";
export var button = "CookieConsent-module--button--LLBYM";
export var buttonApprove = "CookieConsent-module--button--approve--DBKMT";
export var buttonDecline = "CookieConsent-module--button--decline--YkmzB";
export var buttonGroup = "CookieConsent-module--button-group--s61y7";
export var component = "CookieConsent-module--component--jj8YI";
export var description = "CookieConsent-module--description--Ysa6Z";
export var more = "CookieConsent-module--more--sTj8s";
export var title = "CookieConsent-module--title--UszG5";
export var top = "CookieConsent-module--top--7zRVw";
export var topLeft = "CookieConsent-module--topLeft--+KLxV";
export var topRight = "CookieConsent-module--topRight--V3VKl";